import React, { Component } from 'react';
import FJHandleButton from './FJHandleButton';
import classNames from 'classnames';
import Styles from './FJSwipe.module.less';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
class FJSwipe extends Component {
    constructor(props) {
        super(props);
        this.containerWidth = 0;
        this.trackWidth = 0;
        this.maxPastWidth = 0;
        this.flushUpdateView = false;
        this.state = {
            pastWidth: 0,
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.updateView);
        this.updateView();
        this.props.needUpdate && (this.un = FJEvent.subscribe(FJ_EVENT_TYPE.UPDATE_SWIPER_VIEW, this.updateView));
    }

    componentWillUnmount() {
        // 确保在组件卸载时移除事件监听器
        window.removeEventListener('resize', this.updateView);
        this.un && this.un();
    }

    componentDidUpdate() {
        if (this.flushUpdateView && this.container.getBoundingClientRect().width) {
            this.flushUpdateView = false;
            setTimeout(this.updateView, 300);
        }

        if (this.props.triggerLastItem) {
            let isLast = Math.abs(this.state.pastWidth) === this.maxPastWidth;
            let full = this.maxPastWidth > 0;
            this.props.triggerLastItem({ full, isLast });
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.children.length !== nextProps.children.length) {
            this.flushUpdateView = true;
        }
        return true;
    }

    changeToFirst() {
        this.setState({ pastWidth: 0 });
    }
    contentHandleClick = e => {
        let { itemWidth = 300, space } = this.props;

        let element = e.target;
        while (element.parentElement && element.parentElement.className !== Styles.track) {
            element = element.parentElement;
        }
        if (
            !element ||
            !element.parentElement ||
            !(element.parentElement && element.parentElement.className === Styles.track)
        ) {
            return;
        }

        const containerRect = this.container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        // this.track

        // Check if the element is fully visible in the container
        if (elementRect.left < containerRect.left || elementRect.right > containerRect.right) {
            // Calculate the amount to scroll
            const scrollAmount =
                elementRect.left < containerRect.left
                    ? elementRect.left - containerRect.left - (itemWidth + space) * 1.5
                    : elementRect.right - containerRect.right + (itemWidth + space) * 1.5;

            // Update the pastWidth to scroll the element into view
            let newPastWidth = this.state.pastWidth + scrollAmount;
            newPastWidth = newPastWidth < 0 ? 0 : newPastWidth;
            newPastWidth = newPastWidth > this.maxPastWidth ? this.maxPastWidth : newPastWidth;

            this.setState({ pastWidth: newPastWidth }, this.updateView);
        }
    };
    render() {
        let { itemWidth = 300, space = 12, style = {}, trackStyle = {}, handleStyle = {}, className } = this.props;
        let childrenLength = this.props.children.length;
        let trackWidth = childrenLength * itemWidth + (childrenLength - 1) * space;
        let offset = -this.state.pastWidth;
        let isLast = Math.abs(offset) === this.maxPastWidth;
        let full = this.maxPastWidth > 0;
        let handleLeftClassName = classNames(Styles.handler, Styles.handlerLeft, {
            [Styles.active]: full && Math.abs(offset) !== 0,
        });
        let handleRightClassName = classNames(Styles.handler, Styles.handlerRight, {
            [Styles.active]: full && !isLast,
        });
        return (
            <div
                ref={ele => (this.container = ele)}
                style={{ ...style }}
                className={classNames(Styles.container, className)}
            >
                {this.renderLeftHandle(handleStyle, handleLeftClassName)}
                <div className={Styles.content}>
                    <div
                        ref={ele => (this.track = ele)}
                        style={{
                            transform: 'translateX(' + (full && isLast ? offset : offset) + 'px)',
                            width: trackWidth,
                            ...trackStyle,
                        }}
                        className={Styles.track}
                        onClick={this.contentHandleClick}
                    >
                        {this.props.children}
                    </div>
                </div>
                {this.renderRightHandle(handleStyle, handleRightClassName)}
            </div>
        );
    }

    handleRight = () => {
        if (this.containerWidth === 0) {
            this.updateView();
        }
        let pastWidth = this.state.pastWidth + this.containerWidth;
        pastWidth = pastWidth > this.maxPastWidth ? this.maxPastWidth : pastWidth;
        this.setState({ pastWidth: this.parsePastWidth(pastWidth) }, this.updateView);
    };

    handleLeft = () => {
        if (this.containerWidth === 0) {
            this.updateView();
        }
        let pastWidth = this.state.pastWidth - this.containerWidth;
        pastWidth = pastWidth < 0 ? 0 : pastWidth;
        this.setState({ pastWidth: this.parsePastWidth(pastWidth) }, this.updateView);
    };

    parsePastWidth = pastWidth => {
        if (pastWidth === this.maxPastWidth) {
            return pastWidth;
        }
        let iWidth = this.props.itemWidth + this.props.space;
        return Math.floor(pastWidth / iWidth) * iWidth;
    };

    updateView = () => {
        if (!this.container || !this.track) {
            return;
        }
        this.containerWidth = this.container.getBoundingClientRect().width;
        this.trackWidth = this.track.getBoundingClientRect().width;
        if (this.containerWidth === 0 || this.trackWidth === 0) {
            return;
        }
        this.maxPastWidth = this.trackWidth - this.containerWidth;
        this.maxPastWidth = this.maxPastWidth < 0 ? 0 : this.maxPastWidth;
        let curPastWidth = this.state.pastWidth;
        curPastWidth = curPastWidth < 0 ? 0 : curPastWidth;
        curPastWidth = curPastWidth > this.maxPastWidth ? this.maxPastWidth : curPastWidth;
        this.setState({ pastWidth: curPastWidth });
    };

    renderLeftHandle = (handleStyle, handleClassName) => {
        if (this.props.renderLeftHandle) {
            this.props.renderLeftHandle(this.handleLeft);
        } else {
            return <FJHandleButton style={handleStyle} onClick={this.handleLeft} className={handleClassName} />;
        }
    };
    renderRightHandle = (handleStyle, handleClassName) => {
        if (this.props.renderRightHandle) {
            this.props.renderLeftHandle(this.handleRight);
        } else {
            return <FJHandleButton style={handleStyle} onClick={this.handleRight} className={handleClassName} />;
        }
    };
}

export default FJSwipe;
